import React, { useState } from "react";
import Navigation from "../../components/navigation/Navigation";
import { sendUserOtp, setAuthPassword } from "../../sdk/auth/auth";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

const NewPassword = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { auth } = useAuth();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const toggleNewPasswordVisibility = () => {
    setShowNewPassword(!showNewPassword);
  };
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const auth = await JSON.parse(localStorage.getItem("auth"));
      let id = auth?.user?.id;

      if (newPassword === confirmNewPassword) {
        const result = await setAuthPassword(id, newPassword, currentPassword);
        if (
          result.data.statusCode === 200 ||
          result.data.status === 200 ||
          result.data.message === "Success" ||
          result.statusCode === 200
        ) {
          // send otp
          const final = await sendUserOtp(auth?.user?.id);
          if (final.statusCode === 200) {
            navigate("/verification");
          }
          console.log(final);
        }
      } else {
        toast.error("Passwords do not match");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  return (
    <>
      <div className="w-[100%] h-[calc(100vh)] min-h-[85vh] bg-[#FFF] relative">
        <div className="flex items-center h-full relative">
          <div className="w-[90%] h-[95%] flex items-center px-5 gap-[80px]">
            <div className="w-[652px] bg-[#F0FFFE] relative h-[98%] flex flex-col items-center justify-center rounded-[30px]">
              <img src="/logo.png" alt="Logo" className="z-50" />

              <img
                src="/ground.png"
                alt="background"
                className="w-[80%] z-50 h-[50%]"
              />

              <div className="mt-16">
                <p className="text-[#005C53] text-[32px] font-[500]">
                  Making Your Work Easier To <br />
                  Serve Our Members Better.
                </p>

                <svg
                  width="472"
                  height="46"
                  viewBox="0 0 482 46"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4 42C77.6804 19.2828 221.099 -3.53939 478 6.38599"
                    stroke="#005C53"
                    stroke-width="8"
                    stroke-linecap="round"
                  />
                </svg>
              </div>
            </div>
            <div className="w-[50%] h-[624px] flex items-center">
              <div className="w-[100%] z-50 border-gray bg-white h-[100%] flex px-[20px] flex-col justify-center ">
                <p className="text-[20px] text-[#005C53] mb-[10px] font-[500]">
                  Set up your account
                </p>
                <p className="text-[15px] text-[#000000] mb-[10px]">
                  Welcome {auth?.user?.firstname}, create your password by
                  filling in the fields <br /> below
                </p>
                <form onSubmit={handleSubmit}>
                  <div className="flex gap-[5px] mt-5 mb-[15px] w-[95%] flex-col">
                    <label className="text-[#000] text-[14px]" htmlFor="username">
                      Current Password
                    </label>
                    <div className="relative">
                      <input
                        type={showPassword ? "text" : "password"}
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        placeholder="Enter password"
                        className="border w-full rounded-[5px] h-[43px] px-[20px] focus:outline-none"
                      />
                      <span
                        onClick={togglePasswordVisibility}
                        className="absolute top-[50%] right-[10px] transform translate-y-[-50%] cursor-pointer"
                      >
                        {showPassword ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="22"
                            height="22"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fill="currentColor"
                              d="M21.92 11.6C19.9 6.91 16.1 4 12 4s-7.9 2.91-9.92 7.6a1 1 0 0 0 0 .8C4.1 17.09 7.9 20 12 20s7.9-2.91 9.92-7.6a1 1 0 0 0 0-.8M12 18c-3.17 0-6.17-2.29-7.9-6C5.83 8.29 8.83 6 12 6s6.17 2.29 7.9 6c-1.73 3.71-4.73 6-7.9 6m0-10a4 4 0 1 0 4 4a4 4 0 0 0-4-4m0 6a2 2 0 1 1 2-2a2 2 0 0 1-2 2"
                            />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="22"
                            height="22"
                            viewBox="0 0 32 32"
                          >
                            <path
                              fill="none"
                              stroke="currentColor"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M21 16a5 5 0 0 1-5 5m-5-5a5 5 0 0 1 5-5m-3 13.654A13.38 13.38 0 0 0 16 25c7.18 0 13-6 13-9c0-1.336-1.155-3.268-3.071-5M19.5 7.47A13.49 13.49 0 0 0 16 7C8.82 7 3 13 3 16c0 1.32 1.127 3.22 3 4.935M7 25L25 7"
                            />
                          </svg>
                        )}
                      </span>
                    </div>
                  </div>
                  <div className="flex gap-[5px] mt-5 w-[95%] flex-col">
                    <label className="text-[#000] text-[14px]" htmlFor="password">
                      New Password
                    </label>
                    <div className="relative">
                      <input
                        type={showNewPassword ? "text" : "password"}
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        placeholder="Enter password"
                        className="border w-full rounded-[5px] h-[43px] px-[20px] focus:outline-none"
                      />
                      <span
                        onClick={toggleNewPasswordVisibility}
                        className="absolute top-[50%] right-[10px] transform translate-y-[-50%] cursor-pointer"
                      >
                        {showNewPassword ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="22"
                            height="22"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fill="currentColor"
                              d="M21.92 11.6C19.9 6.91 16.1 4 12 4s-7.9 2.91-9.92 7.6a1 1 0 0 0 0 .8C4.1 17.09 7.9 20 12 20s7.9-2.91 9.92-7.6a1 1 0 0 0 0-.8M12 18c-3.17 0-6.17-2.29-7.9-6C5.83 8.29 8.83 6 12 6s6.17 2.29 7.9 6c-1.73 3.71-4.73 6-7.9 6m0-10a4 4 0 1 0 4 4a4 4 0 0 0-4-4m0 6a2 2 0 1 1 2-2a2 2 0 0 1-2 2"
                            />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="22"
                            height="22"
                            viewBox="0 0 32 32"
                          >
                            <path
                              fill="none"
                              stroke="currentColor"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M21 16a5 5 0 0 1-5 5m-5-5a5 5 0 0 1 5-5m-3 13.654A13.38 13.38 0 0 0 16 25c7.18 0 13-6 13-9c0-1.336-1.155-3.268-3.071-5M19.5 7.47A13.49 13.49 0 0 0 16 7C8.82 7 3 13 3 16c0 1.32 1.127 3.22 3 4.935M7 25L25 7"
                            />
                          </svg>
                        )}
                      </span>
                    </div>
                  </div>
                  <div className="text-[#005C53] text-[13px] font-[300] mt-1">
                    <p>
                      Password must contain a  letter and a number, a special
                      character and <br /> be minimum of 8 characters
                    </p>
                  </div>
                  <div className="flex gap-[5px] mt-5 w-[95%] flex-col">
                    <label className="text-[#000] text-[14px]" htmlFor="password">
                      Confirm New Password
                    </label>
                    <div className="relative">
                      <input
                        type={showConfirmPassword ? "text" : "password"}
                        value={confirmNewPassword}
                        onChange={(e) => setConfirmNewPassword(e.target.value)}
                        placeholder="Enter password"
                        className="border w-full rounded-[5px] h-[43px] px-[20px] focus:outline-none"
                      />
                      <span
                        onClick={toggleConfirmPasswordVisibility}
                        className="absolute top-[50%] right-[10px] transform translate-y-[-50%] cursor-pointer"
                      >
                        {showConfirmPassword ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="22"
                            height="22"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fill="currentColor"
                              d="M21.92 11.6C19.9 6.91 16.1 4 12 4s-7.9 2.91-9.92 7.6a1 1 0 0 0 0 .8C4.1 17.09 7.9 20 12 20s7.9-2.91 9.92-7.6a1 1 0 0 0 0-.8M12 18c-3.17 0-6.17-2.29-7.9-6C5.83 8.29 8.83 6 12 6s6.17 2.29 7.9 6c-1.73 3.71-4.73 6-7.9 6m0-10a4 4 0 1 0 4 4a4 4 0 0 0-4-4m0 6a2 2 0 1 1 2-2a2 2 0 0 1-2 2"
                            />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="22"
                            height="22"
                            viewBox="0 0 32 32"
                          >
                            <path
                              fill="none"
                              stroke="currentColor"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M21 16a5 5 0 0 1-5 5m-5-5a5 5 0 0 1 5-5m-3 13.654A13.38 13.38 0 0 0 16 25c7.18 0 13-6 13-9c0-1.336-1.155-3.268-3.071-5M19.5 7.47A13.49 13.49 0 0 0 16 7C8.82 7 3 13 3 16c0 1.32 1.127 3.22 3 4.935M7 25L25 7"
                            />
                          </svg>
                        )}
                      </span>
                    </div>
                  </div>
                  {/* <div className="h-[135px] bg-[#D3EAFF] w-full mt-[15px] rounded-[5px] p-[10px] border border-[#005C53]">
                    <p className="text-[#000] text-[14px] mb-[10px]">
                      Your password must contain the requirements below:
                    </p>
                    <ul className="text-[#000] list-disc list-inside">
                      <li className="pl-[10px]">At least 8 characters</li>
                      <li className="pl-[10px]">At least 1 uppercase letter</li>
                      <li className="pl-[10px]">At least 1 lower letter</li>
                      <li className="pl-[10px]">A special character</li>
                    </ul>
                  </div> */}
                  <button className="bg-[#005C53] mt-5 text-white rounded-[5px] w-[100%] h-[44px]">
                    Login
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewPassword;
